import { render, staticRenderFns } from "./AddAnswerForm.vue?vue&type=template&id=2db2e146&scoped=true"
import script from "./AddAnswerForm.vue?vue&type=script&lang=js"
export * from "./AddAnswerForm.vue?vue&type=script&lang=js"
import style0 from "./AddAnswerForm.vue?vue&type=style&index=0&id=2db2e146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db2e146",
  null
  
)

export default component.exports